import { render, staticRenderFns } from "./ProducerDetails.vue?vue&type=template&id=5250ee62&scoped=true"
import script from "./ProducerDetails.vue?vue&type=script&lang=js"
export * from "./ProducerDetails.vue?vue&type=script&lang=js"
import style0 from "./ProducerDetails.vue?vue&type=style&index=0&id=5250ee62&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5250ee62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5250ee62')) {
      api.createRecord('5250ee62', component.options)
    } else {
      api.reload('5250ee62', component.options)
    }
    module.hot.accept("./ProducerDetails.vue?vue&type=template&id=5250ee62&scoped=true", function () {
      api.rerender('5250ee62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/producers/ProducerDetails.vue"
export default component.exports